import { atom } from "recoil";
import { Category } from "../components/common/Sidebar/_sidebar";

export const currentCategoryState = atom<Category[] | [] | null>({
  key: "currentCategory",
  default: [],
});
